<div class="container">
  <div class="row">
    <div class="col-md-2 col-lg-3"></div>
    <div class="col-md-8 col-lg-6">
      <div class="card">
        <div class="card-body">
          <div class="py-5 my-5"></div>
          <h3 class="card-title text-center">Page not Found</h3>
          <p class="text-center text-muted">The requested page could not be found.</p>
          <div class="py-5 my-5"></div>
        </div>
      </div>
      <div class="py-3"></div>
    </div>
  </div>
</div>
